import { render, staticRenderFns } from "./CalUserSettings.vue?vue&type=template&id=54c992b2&"
import script from "./CalUserSettings.vue?vue&type=script&lang=js&"
export * from "./CalUserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports